'use client';

import { bunja } from 'bunja';
import { createScopeFromContext } from 'bunja/react';
import { PropsWithChildren, createContext } from 'react';
import { AbstractIntlMessages, NamespaceKeys, NestedKeyOf, createTranslator, useMessages } from 'use-intl';

import { useSupportedLocale } from './hooks';
import { SupportedLocale } from './types';

export { FormattedMessage } from './formatted-message';

export const LocaleContext = createContext<SupportedLocale>('en');
export const LocaleScope = createScopeFromContext(LocaleContext);

export const MessagesContext = createContext<AbstractIntlMessages>({});
export const MessagesScope = createScopeFromContext(MessagesContext);

export const I18nProvider = ({ children }: PropsWithChildren) => {
  const locale = useSupportedLocale();
  const messages = useMessages();
  return (
    <LocaleContext value={locale}>
      <MessagesContext value={messages}>{children}</MessagesContext>
    </LocaleContext>
  );
};

export const i18nBunja = bunja(() => {
  const locale = bunja.use(LocaleScope);
  const messages = bunja.use(MessagesScope);
  function getT<NestedKey extends NamespaceKeys<IntlMessages, NestedKeyOf<IntlMessages>> = never>(
    namespace?: NestedKey,
  ) {
    // next-intl 패키지의 내부 타입 문제로 타입 검사가 통과하지 않습니다.
    // 참고: https://github.com/amannn/next-intl/blob/v3.26.4/packages/use-intl/src/core/createTranslator.tsx
    // ts 언어서버에서는 타입 오류가 발생하지 않는데 tsc로 전체 검사할 때 오류가 발생하기 때문에
    // ts-expect-error 대신 ts-ignore를 사용합니다.
    // @ts-ignore
    return createTranslator<NestedKey>({ locale, messages, namespace });
  }
  return { getT };
});
